<li class="cards-item" data-id="{{id}}">
  <img src="{{image}}" alt="" class="cards-list__image" />
  <h3 class="cards-list__title">{{name}}</h3>
  <p class="cards-list__date">{{date}}</p>
  <div class="cards-place">
    <p class="cards-place__text">{{place}}</p>
  </div>
</li>